import React from 'react'
import PropTypes from 'prop-types'

const Radio = (props) => (
    <>
      <label onClick={() => props.onClick && props.onClick} className='radio-label'>
        <input type='radio'  className='radio-input' {...props} />
        <span className='checkmark' />
        <span className='radio-label-text'>{props.label}</span>
      </label>
    </>
  )

  Radio.propTypes = {
     /* The text that will be displayed along with the radio input */
     label: PropTypes.string,

     /* The checkbox name */
     name: PropTypes.string.isRequired,

     onClick: PropTypes.func,
  }

export default Radio
